import { defineStore } from 'pinia'

/**
 * Converted from store/settings.js.
 *
 * Both Vuex getters duplicated same-named state fields and are gone — in Pinia a
 * getter shadows a same-named state key and makes it readonly, so
 * `this.useDarkMode = x` would fail silently. The field names are the ones kept:
 * this module is persisted, and they name entries in the stored blob.
 */
export const useSettingsStore = defineStore('settings', {
  state: () => ({
    useDarkMode: false,
    doPersistMockData: true,
  }),
  actions: {
    setUseDarkMode(stateToSet: boolean): void {
      this.useDarkMode = stateToSet
    },
    setDoPersistMockData(stateToSet: boolean): void {
      this.doPersistMockData = stateToSet
    },
  },
})
